import Vue from 'vue'
import Main from './main.vue'
import * as PopupManagement from '../../../src/util/popupManagement.js'

let MessageContructor = Vue.extend(Main)
let instance = null;
let instances = [];
let count = 1;

const Message = function(option = {}) {
    if(typeof option === 'string') {
        option = {
            message: option
        }
    }

    instance = new MessageContructor({
        propsData: option
    })
    instance.vm = instance.$mount()
    instance.dom = instance.vm.$el
    instance.dom.style.zIndex = PopupManagement.nextZIndex()
    instance.id = count++
    document.body.appendChild(instance.dom)
    instance.vm.visible = true

    if(instances.length) {
        instances[instances.length - 1].vm.close()
    }

    instances.push(instance)

    return instance.vm;
};

['success', 'warning', 'error', 'info'].forEach(type=> {
    Message[type] = option=> {
        if(typeof option === 'string') {
            option = {
                message: option
            }
        }
        option.type = type

        return Message(option);
    }
})

Message.close = function(id) {
    let index = instances.findIndex(v=> v.id === id);
    if(index !== -1) {
        instances[index].vm.close()
        instances.splice(index, 1)
    }
}

Message.closeAll = function() {
    for(let i = 0, len = instances.length; i < len; i++) {
        Message.close(instances[i].id)
    }
}

export default Message;